import { Component, OnInit } from '@angular/core';
import { faRotateExclamation } from '@fortawesome/pro-light-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '@tech-utils/app-config.service';

@Component({
  selector: 'tech-too-many-attempts',
  templateUrl: './too-many-attempts.component.html',
  styleUrls: ['./too-many-attempts.component.scss']
})
export class TooManyAttemptsComponent implements OnInit {
  public faRotateExclamation = faRotateExclamation;
  public textTooManyAttemps:string;

  constructor(
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.translate.get('k004256').subscribe((text: string) => {
      //Token: You must wait {0} minutes before requesting a new code.
      this.textTooManyAttemps = text.replace('{0}', AppConfig.settings.twoFARetryDelayMinutes );
    });
  }

}
